/*============= CURRENCY FORMATTING ============*/
const wholeNumberOptions: Intl.NumberFormatOptions = {
  style: 'currency',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

const fractionNumberOptions: Intl.NumberFormatOptions = {
  style: 'currency',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const formatCurrency = (language: string, currency: string, value: number) => {
  const baseOptions = Number.isSafeInteger(value) ? wholeNumberOptions : fractionNumberOptions;
  const options: Intl.NumberFormatOptions = { ...baseOptions, currency: currency };
  const result = new Intl.NumberFormat(language, options).format(value).replace(/\s/g, '');
  const nums = result.match(/[\d|.|,]+/);
  if (nums === null) return null;
  const num = nums[0];
  const numIndex = result.indexOf(num);

  let symbol;
  let amount;

  if (numIndex < 0) return null;

  if (numIndex === 0) {
    amount = result.substring(0, num.length);
    symbol = result.substring(num.length);
  } else {
    symbol = result.substring(0, numIndex);
    amount = result.substring(numIndex, result.length);
  }

  return {
    symbol,
    amount,
    codeFirst: numIndex === 0,
  };
};

const formatDate = (date: number, language: string, options: Intl.DateTimeFormatOptions) => {
  // BET365 Specific. We get timezone from URL as override of browser setting.
  const timezone = new URLSearchParams(document.location.search).get('tzname');

  options.timeZone = timezone ?? undefined;
  // Split of date into parts allows easier custom formatting
  return Intl.DateTimeFormat(language, options).format(date);
};

/*============= DATE FORMATTING ============*/
export const formatMatchStartDate = (date: number, language: string): string => {
  return formatDate(date, language, {
    weekday: 'long',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const formatStartTime = (date: number, language: string): string => {
  return formatDate(date, language, {
    weekday: undefined,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const formatHistoricGameDate = (date: number, language: string): string => {
  return formatDate(date, language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour12: false,
  });
};
